import { SectionDivider, useToast } from '@kcd/design-system';

import { MypageMembershipNudge } from '~/domains/plusMembership/components/Nudges';
import { useSyncStorageEffect } from '~/hooks/reactQuery';

import { CouponDiscountBar } from './CouponDiscountBar';
import { FrequentlyNavigation } from './FrequentlyNavigation';
import { FrequentlyOrderedShowcase } from './FrequentlyOrdered/FrequentlyOrderedShowcase';
import { HelpDesk } from './HelpDesk';
import { MembershipDiscountInfo } from './MembershipDiscountInfo';
import { MyPageNavigation } from './MypageNavigation';
import { UserInfo } from './UserInfo';

export function MypageContainer() {
  const toast = useToast();

  useSyncStorageEffect(() => {
    toast('계좌번호를 저장했어요.');
  }, 'SAVE_REFUND_ACCOUNT');

  return (
    <div className="flex flex-col overflow-y-auto">
      <section
        data-dd-privacy="mask"
        className="flex flex-col gap-8 px-20 py-16"
      >
        <UserInfo />
        <CouponDiscountBar />
        <MembershipDiscountInfo />
        <FrequentlyNavigation />
      </section>
      <MypageMembershipNudge />
      <SectionDivider className="mx-0" />
      <FrequentlyOrderedShowcase />
      <MyPageNavigation />
      <SectionDivider className="mx-0" />
      <HelpDesk />
    </div>
  );
}
